
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  display:none;
  z-index:2;
}

  @media (min-width: 768px){:host{
    display:block;
    position:sticky;
    top:var(--top-offset)
}
  }

.se-jump-nav{
  display:flex;
  width:100%;
  background-color:var(--brand-primary-4);
}

.se-jump-nav--container{
  width:100%;
}

.se-jump-nav--list{
  list-style:none;
  display:flex;
  padding:0;
  margin:0;
}

.se-jump-nav--item{
  padding-right:7%;
}

.se-jump-nav--link{
  display:flex;
  position:relative;
  font-weight:var(--fw-medium);
  font-family:var(--ff-dmsans);
  text-decoration:none;
  color:var(--gray-800);
  align-self:center;
  padding:0.75rem 0;
}

.se-jump-nav--link.active-jump::after{
    content:'';
    display:flex;
    position:absolute;
    width:100%;
    height:4px;
    background:var(--brand-primary-1);
    bottom:0;
  }
`;